import { Fragment } from "react/jsx-runtime";
import { ProductItemImage } from "./ProductItemImage";

const maxThumbnails = 3;

export const OrderItemCardList = ({
  orderItems,
}: {
  orderItems: {
    id?: number;
    quantity: number;
    Product: {
      Parent: {
        heroImageUrl: string | null;
      } | null;
    };
  }[];
}) => {
  if (!orderItems.length) {
    return null;
  }

  const numberOfUniqueItems = orderItems.length;

  return (
    <>
      <div className="flex gap-2">
        <>
          {orderItems.slice(0, maxThumbnails).map((orderItem, index) => {
            const imageUrl = orderItem.Product.Parent?.heroImageUrl ?? null;

            return (
              <Fragment key={orderItem.id ?? index}>
                <ProductItemImage imageUrl={imageUrl} />
              </Fragment>
            );
          })}

          {numberOfUniqueItems > maxThumbnails && (
            <div
              className={
                "flex aspect-square h-14 w-14 shrink-0 items-center justify-center rounded-lg border border-1 border-zinc-300 bg-zinc-100 text-base text-zinc-500"
              }
            >
              + {numberOfUniqueItems - maxThumbnails}
            </div>
          )}
        </>
      </div>
    </>
  );
};
